const sortComparer= (a, b) => {
    // null timestamp after anything else
    if (!a.lastMessageTimestamp && !b.lastMessageTimestamp) return 0;
    if (!a.lastMessageTimestamp) return 1;
    if (!b.lastMessageTimestamp) return -1;
    // highest sorts first
    return a.lastMessageTimestamp < b.lastMessageTimestamp ? 1 : -1;
}

export default sortComparer;